export function UserTermsPage() {
  return (
    <>
      <header className="nk-header" id="home">
        <div className="section section-lg section-b-0">
          <div className="section-heading">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-xl-7 col-lg-9">
                  <div className="position-relative text-center">
                    <h2 className="title text-gradient-heading fw-semibold display-6 mb-4">
                      SaaS User Terms and Conditions
                    </h2>
                    <p className="fs-8">
                      The terms that apply to each individual user who accesses
                      and uses the Yapamar marketing intelligence service.
                    </p>
                    <p className="fs-10 text-muted fw-semibold">
                      Last updated: October 14, 2026
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <main className="nk-main">
        <div className="section section-xl section-t-0">
          <div className="section-content">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-xl-8">
                  <div className="nk-entry">
                    <h5>1. Background</h5>
                    <ul>
                      <li>
                        <strong>Application.</strong> These user terms and
                        conditions (<strong>User Terms</strong>) apply to each
                        individual user (<strong>User</strong>) who accesses and
                        uses Yapamar OÜ (<strong>Yapamar</strong>) cloud-based
                        marketing intelligence software-as-a-service offering (
                        <strong>Service</strong>) pursuant to a subscription
                        agreement between Yapamar and User’s employer or
                        organisation (<strong>Customer</strong>). The Service is
                        targeted only at corporate clients for professional use.
                      </li>
                      <li>
                        <strong>Relationship to Customer Agreement.</strong>{' '}
                        User’s access to the Service is granted based on the
                        agreement between Customer and Yapamar (
                        <strong>Customer Agreement</strong>). These User Terms
                        supplement the Customer Agreement. User is responsible
                        for complying with applicable laws and these User Terms.
                        User further acknowledges that Customer is responsible
                        to Yapamar for User’s compliance with these User Terms
                        and the Customer Agreement.
                      </li>
                      <li>
                        <strong>Acceptance.</strong> By indicating acceptance of
                        these User Terms (whether by clicking “I Accept”,
                        ticking a box, or otherwise confirming acceptance) or by
                        accessing or using the Service, User agrees to be bound
                        by these User Terms and accepts Yapamar Privacy Notice (
                        <a
                          href="https://yapamar.com/privacy-policy"
                          target="_blank"
                          rel="noopener noreferrer">
                          https://yapamar.com/privacy-policy
                        </a>
                        ). If User does not agree to the aforesaid, User must
                        not access or use the Service.
                      </li>
                    </ul>

                    <h5>2. Grant of Access</h5>
                    <ul>
                      <li>
                        <strong>Limited Right to Use.</strong> Subject to these
                        User Terms, Yapamar grants User a personal, limited,
                        non-exclusive, non-transferable, revocable right to
                        access and use the Service solely for Customer’s
                        internal business purposes and in accordance with these
                        User Terms and Customer Agreement.
                      </li>
                      <li>
                        <strong>User Seats.</strong> User’s access is subject to
                        the number of user seats purchased by Customer. Yapamar
                        may suspend or terminate User’s access if the number of
                        active Users exceeds the permitted number.
                      </li>
                    </ul>

                    <h5>3. User Account and Credentials</h5>
                    <ul>
                      <li>
                        <strong>Personal Account.</strong> Each User account,
                        including the username and password, is personal to the
                        individual User. User shall not share, transfer or
                        disclose User’s username, password or account
                        credentials to any third party.
                      </li>
                      <li>
                        <strong>Account Security.</strong> User is responsible
                        for maintaining the confidentiality and security of
                        User’s account credentials. User shall immediately
                        notify Customer and Yapamar of any unauthorised use of
                        User’s account or any other security breach.
                      </li>
                      <li>
                        <strong>Accurate Information.</strong> User shall
                        provide accurate, current and complete information when
                        creating an account and shall promptly update such
                        information to maintain its accuracy.
                      </li>
                    </ul>

                    <h5>4. Permitted Use and Restrictions</h5>
                    <ul>
                      <li>
                        <strong>Compliance.</strong> User shall use the Service
                        only in accordance with: (a) these User Terms and the
                        Customer Agreement; (b) applicable laws and regulations;
                        and (c) any instructions or policies provided by
                        Customer or Yapamar.
                      </li>
                      <li>
                        <strong>Prohibited Activities.</strong> User shall not:
                        (a) interfere with or disrupt the integrity or
                        performance of the Service; (b) attempt to gain
                        unauthorised access to the Service or its related
                        systems or networks; (c) remove, alter or obscure any
                        proprietary notices on the Service; (d) use the Service
                        to transmit any viruses, malware or other harmful code;
                        or (e) use the Service in any manner that could damage,
                        disable or impair the Service.
                      </li>
                    </ul>

                    <h5>5. Intellectual Property</h5>
                    <ul>
                      <li>
                        <strong>Yapamar Rights.</strong> User acknowledges and
                        agrees that Yapamar and its licensors hold all rights,
                        title and interest in and to the Service, including all
                        intellectual property rights therein. All rights not
                        expressly granted to User are reserved by Yapamar and
                        its licensors.
                      </li>
                      <li>
                        <strong>Restrictions.</strong> User shall not acquire
                        any rights, title or interest in the Service, related
                        deliverables or outputs other than the limited right to
                        use the Service as expressly set out in these User
                        Terms. The Service and underlying software contain
                        business secrets and proprietary information of Yapamar
                        and third parties. Any copying, modification,
                        translation, decompiling, disassembling or reverse
                        engineering of the Service is strictly prohibited.
                      </li>
                      <li>
                        <strong>Customer Data.</strong> As between User and
                        Yapamar, all data, content and materials uploaded,
                        submitted or created by User in the Service (
                        <strong>User Content</strong>) belongs to Customer. User
                        grants Yapamar the right to use, process and store User
                        Content to the extent necessary to provide the Service
                        to Customer and User in accordance with the Customer
                        Agreement. Further, Yapamar may collect and use
                        aggregated usage data and statistics derived from User’s
                        use of the Service in anonymised form, provided that
                        such data cannot be used to identify Customer, User or
                        any individual. Yapamar may use such anonymised data for
                        product development, benchmarking, analytics and
                        research purposes and may share such data with
                        third-party service providers for these purposes.
                      </li>
                    </ul>

                    <h5>6. Data Protection and Privacy</h5>
                    <ul>
                      <li>
                        <strong>Personal Data.</strong> User acknowledges and
                        agrees that User’s personal data (including account
                        information, contact details and location data) may be
                        processed by Yapamar in accordance with Yapamar Privacy
                        Notice and applicable data protection laws.
                      </li>
                      <li>
                        <strong>User Responsibilities.</strong> User is
                        responsible for ensuring that any personal data or other
                        data uploaded to the Service by User: (a) is uploaded
                        lawfully and in compliance with applicable data
                        protection laws; (b) does not infringe any third-party
                        rights; and (c) complies with these User Terms.
                      </li>
                      <li>
                        <strong>Data Controller.</strong> User acknowledges that
                        for User account and authentication data, Yapamar is the
                        data controller. For any personal data that User submits
                        to the Service in the course of using the Service,
                        Customer is the data controller and Yapamar is the data
                        processor.
                      </li>
                    </ul>

                    <h5>7. Term</h5>
                    <ul>
                      <li>
                        <strong>Term.</strong> These User Terms commence when
                        User first accepts them or first accesses the Service
                        (whichever is earlier) and continue until User’s access
                        to the Service is terminated.
                      </li>
                      <li>
                        <strong>Termination by Customer.</strong> Customer may
                        terminate User’s access to the Service at any time. User
                        acknowledges that Yapamar has no obligation to maintain
                        User’s access if Customer requests termination or if the
                        Customer Agreement terminates.
                      </li>
                      <li>
                        <strong>Termination by Yapamar.</strong> Yapamar may
                        suspend or terminate User’s access to the Service
                        immediately if: (a) User breaches these User Terms; (b)
                        the Customer Agreement terminates or expires; (c)
                        Customer requests termination of User’s access; (d)
                        User’s actions pose a security risk to the Service or
                        other users; or (e) required by law or regulatory
                        authorities.
                      </li>
                      <li>
                        <strong>Effect of Termination.</strong> Upon termination
                        of User’s access, User shall immediately cease all use
                        of the Service. User acknowledges that User has no right
                        to access User Content after termination, and any such
                        access is subject to the Customer Agreement between
                        Customer and Yapamar.
                      </li>
                    </ul>

                    <h5>8. Limitation of Liability</h5>
                    <ul>
                      <li>
                        <strong>No Warranties.</strong> The Service is provided
                        to User “as is” and “as available” without warranties of
                        any kind. User uses the Service at User’s own risk.
                      </li>
                      <li>
                        <strong>Limitation.</strong> To the maximum extent
                        permitted by law, Yapamar shall not be liable to User
                        for any direct, indirect, incidental, consequential or
                        special damages arising out of or related to the Service
                        or use thereof.
                      </li>
                      <li>
                        <strong>Customer Relationship.</strong> User
                        acknowledges that User’s primary relationship is with
                        Customer. Any claims relating to User’s access to or use
                        of the Service should be directed to Customer in the
                        first instance.
                      </li>
                    </ul>

                    <h5>9. Miscellaneous</h5>
                    <ul>
                      <li>
                        <strong>Modifications.</strong> Yapamar may modify these
                        User Terms from time to time by providing notice through
                        the Service or by email. Continued use of the Service
                        after such notice constitutes User’s acceptance of the
                        modified User Terms.
                      </li>
                      <li>
                        <strong>Severability.</strong> If any provision of these
                        User Terms is held to be invalid or unenforceable, the
                        remaining provisions shall remain in full force and
                        effect.
                      </li>
                      <li>
                        <strong>Entire Agreement.</strong> These User Terms,
                        together with the Privacy Notice and the Customer
                        Agreement, constitute the entire agreement between User
                        and Yapamar regarding User’s use of the Service.
                      </li>
                    </ul>

                    <h5>10. Contact</h5>
                    <p>Yapamar OÜ</p>
                    <p className="d-flex align-items-center gap-2 mb-1">
                      <em className="icon ni ni-mail" />
                      <a href="mailto:support@yapamar.com">
                        support@yapamar.com
                      </a>
                    </p>
                    <p className="d-flex align-items-center gap-2">
                      <em className="icon ni ni-map-pin" />
                      Sepapaja 6, Tallinn 15551, Estonia
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
